import React, {useEffect} from 'react';

import S360WidgetBlock from "root/s360components/LearningJournal/S360WidgetBlock";

import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import {FormInputDatePicker, SmartErrorDiv} from "root/ReactHookForm/FormComponents";
import DropdownYearTerms from "root/ReactHookForm/ui/DropdownYearYerms";
import FormFilterPicker from "root/ReactHookForm/ui/FormFilterPicker";
import {useWatch} from "react-hook-form";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import {FormSectionNames} from "root/s360components/LearningJournal/LearningJournalPage";

export const JournalFilters = {
    THIS_YEAR: 0,
    TERM: 1,
    THIS_WEEK: 2,
    CUSTOM: 3,
}

const getCurrentWeekStartAndEnd = () =>
{
    const now = new Date() ;

    const dt_start = startOfWeek(now, { weekStartsOn: 1, locale: { code: 'en-GB' }} ) ;
    const dt_end = endOfWeek(now, { weekStartsOn: 1, locale: { code: 'en-GB' }} ) ;

    return { start: dt_start, end: dt_end } ;
}

const getCurrentYearStartAndEnd = () =>
{
    const now = new Date() ;

    const month = Number(format(now, 'MM')) ;
    const year = Number(format(now, 'y')) ;

    const academicYear = ( month >= 1 && month <= 9 ) ? year - 1 : year ;

    const startStr = '01/09/' + academicYear ;
    const endStr = '31/08/' + ( academicYear + 1 );

    const dt_start = parse(startStr, 'dd/MM/yyyy', new Date());
    const dt_end = parse(endStr, 'dd/MM/yyyy', new Date());

    return { start: dt_start, end: dt_end } ;
}
export const dateRange = () =>
{
    const { start: initStart , end: initEnd } = getCurrentYearStartAndEnd() ;

    return {
        [FormSectionNames.DATE_RANGE]:
            {
                filter: null,
                term: null,
                start_date: initStart,
                end_date: initEnd,
            }
    }
}
const HookSubFormDateRangeSelector = ({control, resetField, getValues, formErrors, sectionName, readOnly}) =>
{
    const termFilter = useWatch({
        control: control,
        name: sectionName + '.' + 'filter',
    });

    const currentTerm = useWatch({
        control: control,
        name: sectionName + '.' + 'term',
    });

    const resetDates = ( {start, end} ) =>
    {
        const cur = getValues(sectionName);

        resetField(sectionName, {defaultValue: {...cur, start_date: start, end_date: end}});
    }

    useEffect(() =>
    {
        console.log ( termFilter );

        switch ( termFilter )
        {
            case JournalFilters.THIS_WEEK:
            {
                resetDates ( getCurrentWeekStartAndEnd()) ;
                break;
            }
            case JournalFilters.THIS_YEAR:
            {
                resetDates ( getCurrentYearStartAndEnd()) ;
                break;
            }
        }
    }, [termFilter]);

    useEffect(() =>
    {
        if ( currentTerm !== null )
        {
            const start = parse(currentTerm.date_from, 'dd/MM/yyyy', new Date());
            const end = parse(currentTerm.date_to, 'dd/MM/yyyy', new Date());

            resetDates ( {start, end} ) ;
        }
    }, [currentTerm?.value]);

    const validateTerm = (val) =>
    {
        if (val === null)
        {
            return "Please Select a Term.";
        }
    }

    const values = [
        { offset: JournalFilters.THIS_YEAR, label: 'This Year'},
        { offset: JournalFilters.TERM, label: 'Term'},
        { offset: JournalFilters.THIS_WEEK, label: 'This Week'},
        { offset: JournalFilters.CUSTOM, label: 'Custom Dates'},
    ]

    return (
        <S360WidgetBlock title='Select the date range'>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormFilterPicker values={values} name={sectionName + '.filter'} control={control}/>
                </BootstrapCol>
            </BootstrapRow>

            { termFilter === JournalFilters.TERM && <BootstrapRow>
                <BootstrapCol width={12}>
                    <DropdownYearTerms academic_year='current' placeholder='Pick a term'  name={sectionName + '.term'} control={control} rules={{validate: validateTerm}}
                                       placeHolder='Pick a term' />
                    <SmartErrorDiv sectionName={sectionName}  name={'term'} formErrors={formErrors} />
                </BootstrapCol>
            </BootstrapRow> }

            { termFilter === JournalFilters.CUSTOM &&
                <BootstrapRow>
                    <BootstrapCol width={6} style={{marginTop: '15px'}}>
                        <FormInputDatePicker readOnly={readOnly} label='Pick a start date' sectionName={sectionName}
                                             name={'start_date'} control={control} required={true}
                                             formErrors={formErrors}/>
                    </BootstrapCol>
                    <BootstrapCol width={6} style={{marginTop: '15px'}}>
                        <FormInputDatePicker readOnly={readOnly} label='Pick an end date' sectionName={sectionName}
                                             name={'end_date'} control={control} required={true}
                                             formErrors={formErrors}/>
                    </BootstrapCol>
                </BootstrapRow>
            }
        </S360WidgetBlock>
    )
}


export default HookSubFormDateRangeSelector;
